export const EQUIPMENT_LIST_REQUESTED = "EQUIPMENT_LIST_REQUESTED";
export const EQUIPMENT_LIST_SUCCEEDED = "EQUIPMENT_LIST_SUCCEEDED";
export const EQUIPMENT_LIST_FAILED = "EQUIPMENT_LIST_FAILED";

export const EQUIPMENT_CREATE_REQUESTED = "EQUIPMENT_CREATE_REQUESTED";
export const EQUIPMENT_CREATE_SUCCEEDED = "EQUIPMENT_CREATE_SUCCEEDED";
export const EQUIPMENT_CREATE_FAILED = "EQUIPMENT_CREATE_FAILED";

export const EQUIPMENT_UPDATE_REQUESTED = "EQUIPMENT_UPDATE_REQUESTED";
export const EQUIPMENT_UPDATE_SUCCEEDED = "EQUIPMENT_UPDATE_SUCCEEDED";
export const EQUIPMENT_UPDATE_FAILED = "EQUIPMENT_UPDATE_FAILED";

export const EQUIPMENT_DELETE_REQUESTED = "EQUIPMENT_DELETE_REQUESTED";
export const EQUIPMENT_DELETE_SUCCEEDED = "EQUIPMENT_DELETE_SUCCEEDED";
export const EQUIPMENT_DELETE_FAILED = "EQUIPMENT_DELETE_FAILED";

// Routes
export const EQUIPMENT_ROUTE = `/equipment`;
export const EQUIPMENT_USAGE_LIST_ROUTE = `/equipment-usage`;
export const EQUIPMENT_USAGE_ADD_ROUTE = `/equipment-usage/add`;
export const EQUIPMENT_USAGE_EDIT_ROUTE = `/equipment-usage/edit/:usageId`;
export const EQUIPMENT_MEMBER_ROUTE = `${EQUIPMENT_ROUTE}/:equipmentId`;

export default {
	EQUIPMENT_LIST_REQUESTED,
	EQUIPMENT_LIST_SUCCEEDED,
	EQUIPMENT_LIST_FAILED,
	EQUIPMENT_CREATE_REQUESTED,
	EQUIPMENT_CREATE_SUCCEEDED,
	EQUIPMENT_CREATE_FAILED,
	EQUIPMENT_UPDATE_REQUESTED,
	EQUIPMENT_UPDATE_SUCCEEDED,
	EQUIPMENT_UPDATE_FAILED,
	EQUIPMENT_DELETE_REQUESTED,
	EQUIPMENT_DELETE_SUCCEEDED,
	EQUIPMENT_DELETE_FAILED,
	EQUIPMENT_ROUTE,
	EQUIPMENT_USAGE_LIST_ROUTE,
	EQUIPMENT_USAGE_ADD_ROUTE,
	EQUIPMENT_USAGE_EDIT_ROUTE,
	EQUIPMENT_MEMBER_ROUTE
};

